<template>
    <div class="section-marche-revente">
        <div class="tle-row">
            <div class="tle-col three-quarter">
                <el-table
                :table="marche_revente_table"
                :lines-obj="
                    active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
                "
                lines-field="marche_revente_table_lines"
                lines-box-class="line-box-negative-margin-top"
                nb-lines-max="5"
                />
            </div>
            <div class="tle-col one-quarter self-end">
                <el-square
                :parent_data="
                    active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
                "
                property="prix_moyen_secteur"
                label="Prix/m² median sur le secteur"
                format="string"
                suffix="€/m²"
                :editable="true"
                />
                <el-square
                :parent_data="
                    active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
                "
                property="evolution"
                label="Évolution"
                format="string"
                suffix="%"
                class="q-mt-sm"
                :editable="true"
                />
				<div v-if="this.active_study.etudeType.nom==='Flash'">
					<div
					class="el-closed-question q-mt-sm q-mb-md"
					:class="{ 'can-change': editor.mode == 'editing' }"
					>
					<div class="question-label">
						<div>Prix stationnement</div>
					</div>
					<span class="question-value">
						<el-textarea
						:parent_data="
							active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
						"
						property="prix_stationnement"
						:editable="true"
						:money_parse="true"
						:suffix= "'€'"
						/>
					</span>
					</div>
				</div>
            </div>
        </div>

        <div v-if="this.active_study.etudeType.nom!=='Flash'" class="tle-row">
            <div class="tle-col three-quarter">
                <div
                class="el-closed-question q-mt-sm q-mb-md"
                :class="{ 'can-change': editor.mode == 'editing' }"
                >
                <div class="question-label">
                    <div>Prix stationnement</div>
                </div>
                <span class="question-value">
                    <el-textarea
                    :parent_data="
                        active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
                    "
                    property="prix_stationnement"
                    :editable="true"
					:money_parse="true"
					:suffix= "'€'"
                    />
                </span>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { mapGetters } from "vuex";

import number from "@/libs/number";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
export default {
	mixins: [PageMixin],
	computed: {
		...mapGetters([
			"active_study",
			"etude_data",
			"app_parameters",
			"editor",
			"marche_revente_table_lines"
		]),
		marche_revente_table_lines () {
			return parseInt(
				this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
					.marche_revente_table_lines
			);
		},
		marche_revente_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [10, 20, 20, 25, 25],
				},
			};

			table.head.push([
				"Type",
				"Intensité des transactions",
				"Surf. hab.",
				"Prix unitaire",
				"Prix/m²",
			]);

			for (let i = 0; i < this.marche_revente_table_lines; i++) {
				const loc =
			this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
				.marche_revente_table[i];

				const rows = [
					{ parent_data: loc, property: "type", editable: true },
					{
						parent_data: loc,
						property: "intensite_transactions",
						editable: true,
					},
					{
						parent_data: loc,
						property: "surf_hab",
						editable: true,
						suffix: " m²",
					},
					{
						value: number.format(loc.prix_unit, 1),
						parent_data: loc,
						property: "prix_unit",
						editable: true,
						suffix: " €",
					},
					{
						value: number.format(loc.prix_m2, 1),
						parent_data: loc,
						property: "prix_m2",
						editable: true,
						suffix: " €",
					},
				];

				table.body.push(rows);
			}

			return table;
		},
	}
};
</script>
